import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';

const ForgotPasswordSteps = ({ t, currentStep }) => {
  const classNameByStep = (step) => {
    let className = 'im-step-bar2__item';
    if (step === currentStep) {
      className = `${className} im-step-bar2__item--inprogress`;
    } else if (step < currentStep) {
      className = `${className} im-step-bar2__item--completed`;
    }
    return className;
  };

  return (
    <div className="col-md-5 col-lg-4">
      <aside>
        <nav className="im-step-bar2 im-step-bar2--numbers">
          <a className={classNameByStep(0)}>
            <span className="im-step-bar2__item__text">{t('enterEmailAddress')}</span>
          </a>
          <a className={classNameByStep(1)}>
            <span className="im-step-bar2__item__text">{t('verifyYourEmailAddress')}</span>
          </a>
          <a className={classNameByStep(2)}>
            <span className="im-step-bar2__item__text">{t('createNewPassord')}</span>
          </a>
        </nav>
      </aside>
    </div>
  );
};

ForgotPasswordSteps.propTypes = {
  currentStep: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation('common')(ForgotPasswordSteps);
